import qs from 'qs'

export const removeUrlParameter = (url: string, paramKey: string) => {
  const r = new URL(url)
  r.searchParams.delete(paramKey)
  return r.href
}

export const updateCloudinaryUrlWidth = (url: string | undefined, tilesLength: number) => {
  if (tilesLength <= 0 || !url) {
    return url || ''
  }
  if (tilesLength === 3) {
    return url.replace(
      /(\/images\/[^/]*?)([/,])w_\d+([,/])/,
      (_, prefix, before, after) => `${prefix}${before}w_800${after}`
    )
  }
  return url
}

export const appendQueryParams = (url: string, queryParams: string) => {
  const existingParams = url.split('?')[1]

  const separator = existingParams ? '&' : '?'

  const newUrl = `${url}${separator}${queryParams}`

  return newUrl
}

export const getQueryParametersFromUrl = (): Record<string, string> => {
  try {
    return qs.parse(window?.location?.search?.substring(1) || '') as Record<string, string>
  } catch {
    return {}
  }
}
